import React from "react";
import { Col, Row, Form, FloatingLabel } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

function MetaInformation() {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div>
      <Row className=" gx-2 gy-2">
        <Col md="12">
          <Form.Group controlId="metaTags">
            <FloatingLabel label="Meta Tags">
              <Form.Control
                as="textarea"
                placeholder="Meta Tags"
                style={{ height: "80px" }}
                {...register("metaKeyword")}
                isInvalid={!!errors.metaKeyword}
              />
            </FloatingLabel>
            <Form.Control.Feedback type="invalid">
              {errors.metaKeyword?.message}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md="12">
          <Form.Group controlId="metaDescription">
            <FloatingLabel label="Meta Description">
              <Form.Control
                as="textarea"
                placeholder="Meta Description"
                style={{ height: "110px" }}
                {...register("metaDescription")}
                isInvalid={!!errors.metaDescription}
              />
            </FloatingLabel>
            <Form.Control.Feedback type="invalid">
              {errors.metaDescription?.message}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
}

export default MetaInformation;
